export const externalLinks = Object.freeze({
    researcher: {
      loginFenix: "https://ansokan.cancerfonden.se/sbs/forskning/grandid/user/login/selectidp/bankid.deviceChoice",
      createAccountFenix: "https://ansokan.cancerfonden.se/sbs/forskning/minsida/signup",
      loginAssessor: "https://ansokan.cancerfonden.se/granskningsportal/sbs/forskning/login"
    } 
});